export default __webpack_public_path__ + "static/media/coloredLogo.fa360486.svg";